import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from './AuthenticationContext';

const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useContext(AuthContext);
    
    if (loading) {
        return <div>Loading...</div>;
    }

    // Check if user is authenticated, if not redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default ProtectedRoute; 